import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import FileUploader from "../../../TCPForms/reusableComponents/FileUploader";
import ButtonWrapper from "../../components/Button";
import { InfoBox, SummaryCard } from "../../components/StyledComponent";
import { FaFilePdf } from "react-icons/fa";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import { use } from "react";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";

const Step2 = ({ formData, handleTabChange, tenantId }) => {
  const dispatch = useDispatch();
  const { initFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const { documents } = useSelector((state) => state.formMT);
  const userInfo = Digit.UserService.getUser();
  const { t } = useTranslation();
  const isDA = formData?.department === "DA";
  const isLowRiskCase = formData?.riskType === "LOW";
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const defaultValues = {
    ...formData,
  };
  const isScheme = formData?.descriptionOfLand?.schemeType === "Scheme";
  const isSelfCert = formData?.planOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const { handleSubmit, control, setValue, trigger } = useForm({ defaultValues });
  async function fetchLTPData() {
    const createdBy = userInfo?.info?.uuid;
    try {
      const response = await Digit.OBPSService.BPAREGSearch(tenantId, {}, { createdBy: createdBy });
      const ltpData = response?.Licenses?.filter((e) => e.status === "APPROVED") || [];
      console.log(response, ltpData, "ltpDataaaaaa");
      const regCert = ltpData?.[0]?.tradeLicenseDetail?.applicationDocuments?.filter((e) => e.documentType === "Registration Certificate") || [];
      initFormMTDocs([...regCert, ...documents]);
    } catch (error) {
      console.error("Error fetching migrated data:", error);
    }
  }

  useEffect(() => {
    fetchLTPData();
  }, []);

  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const onSubmit = (data) => {
    data = {
      ...data,
      nocDetails: formData?.nocDetails,
    };
    console.log("dataFromDocComponent", data);

    handleTabChange(2, data);
  };
  return (
    <section className="groupContainer">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Mandatory Documents")}</h2>
          </div>

          <div className="formInputContainer">
            <div className="columnWrapper">
              <FileUploader
                label={t("Sanction Map")}
                control={control}
                name="Sanction Map"
                validationMsg="(pdf file only and Max file Size 30 MB)"
                required
                isMandatory
                trigger={trigger}
              />

              <FileUploader
                label={t("Sanction Letter")}
                control={control}
                name="Sanction Letter"
                validationMsg="(pdf file only and Max file Size 30 MB)"
                required
                isMandatory
                trigger={trigger}
              />
              <FileUploader
                isMandatory
                label={t("Compounding Drawing PDF")}
                control={control}
                name="drawingPdf"
                validationMsg="(pdf file only and Max file Size 30 MB)"
                required
                trigger={trigger}
              />
            </div>

            <div className="columnWrapper">
              <FileUploader
                isMandatory
                label={t("Compounding drawing dxf")}
                control={control}
                name="drawingPdf"
                validationMsg="(pdf file only and Max file Size 30 MB)"
                required
                trigger={trigger}
              />

              {isSelfCert && (
                <FileUploader
                  isMandatory
                  label={t("Owner Affidavit")}
                  control={control}
                  name="ltpAffidavit"
                  validationMsg="(pdf file only and Max file Size 30 MB)"
                  required
                  trigger={trigger}
                />
              )}

              <FileUploader
                isMandatory
                label={t("Site Photo")}
                control={control}
                name="uptodatePaymentLetter"
                validationMsg="(pdf file only and Max file Size 30 MB)"
                required
                trigger={trigger}
              />
            </div>
          </div>
        </div>

        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Conditional Documents")}</h2>
          </div>

          <div className="formInputContainer">
            <div className="columnWrapper">
              <FileUploader
                label={t("Structural Safety Certificate")}
                control={control}
                name="structuralAuditReport"
                validationMsg="(pdf file only and Max file Size 30 MB)"
              />
            </div>
            <div className="columnWrapper">
              <FileUploader
                label={t("Fire Noc")}
                control={control}
                name="calculationReport"
                validationMsg="(pdf file only and Max file Size 30 MB)"
              />
            </div>
          </div>
        </div>

        <div className="footerContainer">
          <div className="buttonWrapper">
            <ButtonWrapper
              variant="contained"
              color="error"
              size="medium"
              label="Prev"
              sx={{ backgroundColor: "#CCC" }}
              onClick={() => handleTabChange(0)}
            />
            <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
          </div>
        </div>
      </form>
    </section>
  );
};

export default Step2;
